/*
  Main 관리 (2018/06/01 정재윤)
    - App Ready 상태 확인
    - Vue 인스턴스 생성
    - App.vue 로딩
*/

import '~core'
// import '@/_fdp/core/router/index.b2c'
import Router from '~fdp/core/router/router.js'

import Toast from 'vue-toastification'

import './init'

import VueGtm from 'vue-gtm'
// import VueAnalytics from 'vue-analytics'

/* common module import */
import MmpVeeValidate from '@/plugins/_common/MmpVeeValidate'
import VueLoadScript from '@/plugins/_common/VueLoadScript'
import MmpPostMessage from '@/plugins/_common/MmpPostMessage'
import VueSwiper from '@/plugins/_common/VueSwiper'
import MmpBeforeRouteCheck from '@/plugins/_common/MmpBeforeRouteCheck'
import MmpLoading from '@/plugins/_common/MmpLoading'

import MmpToast from '@/components/_common/mmp-toast/MmpToast.vue'
import MmpMessagePlugin from '@/plugins/_common/MmpMessage'
import Vue from 'vue'
import App from './App/App'
import GaDiagLog from '@/plugins/_common/GaDiagLog'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
if (window.vue.config.app.isCssLoaded === undefined) { window.vue.config.app.isCssLoaded = false }

// Vue 인스턴스 생성
const locale = localStorage.getItem('language') || window.vue.config.app.defaultLocale

let mixinPath = ''

let resoursePlugin
if (window.location.hostname.startsWith('bootcamp.')) {
  resoursePlugin = import('@/plugins/_common/kdt/KdtResource')
  mixinPath = import('@/mixin/kdt/kdtGlobalMixin')
} else {
  resoursePlugin = import('@/plugins/_common/MmpResource')
  mixinPath = import('@/mixin/globalMixin')
}
mixinPath
  .then(mixin => {
    Vue.mixin(mixin.default)
  })
  .catch(error => {
    console.error(error)
  })
resoursePlugin
  .then(module => {
    Vue.use(module.default)

    return window.vue.setLocaleResource(locale) // 이 함수도 resoursePlugin 반환해야 함
  })
  .catch(error => {
    console.error(error)
    window.vue.setLocale(locale)
  })
  .finally(() => {
    createVue()
  })
const createVue = async () => {
  /* common module install */
  // let httpObj = window.vue.getInstance('http')
  let UtilsPlugin
  let routeModule
  let popupPlugin
  if (window.location.hostname.startsWith('bootcamp.')) {
    UtilsPlugin = (await import('@/plugins/_common/kdt/KdtUtils')).default
    routeModule = await import('@/config/router/kdt/rootKdtRoutes')
    popupPlugin = (await import('@/plugins/_common/kdt/KdtPopup')).default
  } else {
    UtilsPlugin = (await import('@/plugins/_common/MmpUtils')).default
    routeModule = await import('@/config/router/rootRoutes')
    popupPlugin = (await import('@/plugins/_common/MmpPopup')).default
  }
  // 공통 플러그인 사용
  Vue.use(UtilsPlugin)
  // 선택된 라우터 설정 실행
  await routeModule.default.generateRouter(Router)

  // document.getElementById('app').classList.remove('lds-roller')

  /* common module install */
  Vue.use(popupPlugin)
  Vue.use(MmpVeeValidate)
  Vue.use(VueLoadScript)
  Vue.use(MmpPostMessage)
  Vue.use(VueSwiper)
  Vue.use(MmpLoading)

  let isPhone = Vue.utils.userAgent.isPhone()
  let isTablet = Vue.utils.userAgent.isTablet()
  let isDesktop = Vue.utils.userAgent.isDesktop()
  let isApp = Vue.utils.userAgent.isApp()

  var routerObj = window.vue.getInstance('router')

  console.log('router ', routerObj)
  console.log('userAgent', 'isPhone: ', isPhone ? 'O' : 'X', 'isTablet:', isTablet ? 'O' : 'X', 'isDesktop', isDesktop ? 'O' : 'X', 'isApp', isApp ? 'O' : 'X')

  Vue.use(MmpBeforeRouteCheck)

  // Vue.use(VueAnalytics, {
  //   id: 'GTM-NC3K5VK',
  //   router: routerObj,
  //   checkDuplicatedScript: true
  // })
  let isNrwMobile = window.vue.getStore('mmpAuth').getters.isNrwMobile
  let isKdtMobile = window.vue.getStore('mmpAuth').getters.isKdtMobile
  let gtmId = 'GTM-NC3K5VK' // 이벤트 GTM ID
  if (isNrwMobile) {
    gtmId = 'GTM-NL3KD4HQ' // 닷컴 GTM ID
    Vue.use(GaDiagLog) // 닷컴 GA4 진단 로그 설정
  } else if (isKdtMobile) {
    gtmId = 'GTM-T27ZRCGS' // 부트캠퍼 GTM ID
  }
  Vue.use(VueGtm, {
    id: gtmId,
    vueRouter: routerObj,
    loadScript: true,
    debug: true,
    enable: true
  })
  var MmpToastContainer = Vue.extend(MmpToast)

  var toastContainer = new MmpToastContainer().$mount()
  document.body.appendChild(toastContainer.$el)

  Vue.use(Toast, {
    container: toastContainer.$el
  })

  Vue.use(VueLazyload)
  Vue.use(MmpMessagePlugin)

  if (window.vue.getInstance('vue') === undefined) {
    const vueInstance = new Vue({
      el: '#app',
      components: { App },
      i18n: window.vue.getI18n(),
      router: routerObj,
      render: function (createElement) {
        return createElement(App)
      }
    })
    window.vue.setInstance('vue', vueInstance)
  }
}

// console.log 출력 안 되게 하는 스크립트 production
if (process.env.NODE_ENV === 'production') {
  const muteFunc = function () {}
  window.console.log = muteFunc
  console.log = muteFunc
  console.info = muteFunc
}



// WEBPACK FOOTER //
// ./src/main.js